import React, { Component } from "react";
import { connect } from "react-redux";
import projActions from "../../../_actions/projActions";
import { projSelectorConstants } from "../../../_constants/projSelectorConstants";
import { isNullOrZero } from "../../../_utils/generalUtils";
import { DOCTYPE } from "../../../_constants/docTypeConstants";
import { getPermissions } from "../../../_helpers/authorize";
import _ from "lodash";
import Table from "../../_common/Table";
import ProjSelector from "../../_common/ProjSelector";
import TitleBar from "../../_common/TitleBar";
import Select from "react-select";
import ProjAssignmentDetails from "./projAssignmentDetails";
import EditProjAssignmentModal from "./editProjAssignmentModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { USER } from "../../../_constants/actionConstants";
import { useSelector } from "react-redux";
import "./styles/projAssignment.css";
import EditProjUnitsModal from "./editProjUnitsModal";

class ProjAssignment extends Component {
  state = {
    permissions: [],
    projectId: null,
    selectedTabId: "staff",
    selectedStaff: null,
    selectedUnit: null,
    nameFilter: "",
    roleFilter: null,
    unitFilter: "",
    showEditProjAssignmentModal: false,
    showEditProjUnitsModal: false,
    sortColumn_units: { path: "distUnit", order: "asc" },
    sortColumn_staff: { path: "fullName", order: "asc" },
  };

  /**
   * Use the constructor to initialize the state's projectId to
   * the prop's projectId, if one is provided. If not, prop's
   * projectId remains as default (null). This is necessary to
   * pre-select the project, i.e. when ProjAssignment is accessed
   * from ProjList.
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    if (!isNullOrZero(props.tab.projectId))
      this.state = {
        ...this.state,
        projectId: props.tab.projectId,
      };
  }

  columns_staff = [
    { path: "fullName", label: "Name" },
    { path: "distUnit", label: "Unit" },
    { path: "employeeNo", label: "Emp. No." },
    {
      path: "projectRoleDescription",
      label: "Project Role",
      content: (projStaff) => {
        const pro = this.props.projRoleOptions.find(
          (pro) => pro.value === projStaff.projectRoleId
        );
        return pro ? pro.label : "(N/A)";
      },
    },
  ];

  columns_units = [
    { path: "distUnit", label: "Unit" },
    { path: "unitDescription", label: "Description" },
    { path: "unitManagerFullName", label: "Unit Manager" },
  ];

  tabs = [
    { tabId: "staff", link: "#", label: "Assigned Staff" },
    { tabId: "units", link: "#", label: "Assigned Units" },
  ];

  componentDidMount() {
    const { authentication, tab, dispatch } = this.props;
    dispatch(projActions.fetchProjectRoles());

    // Permissions can be different for every selected project, so if
    // projectId is provided, get permissions.
    // Also, fetch projectUnits.
    if (tab.projectId) {
      dispatch(projActions.fetchAllStaff(tab.projectId));
      dispatch(projActions.fetchProjectUnits(tab.projectId));
      const permissions = getPermissions({
        user: authentication.user,
        docType: DOCTYPE.PROJECT_ASSIGNMENT,
        projectId: tab.projectId,
        creatorId: null,
      });
      this.setState({ permissions });
    }
  }

  /**
   * Whenever a project is selected, fetch projStaffList and projUnitList, and
   * check whether the user has permission to edit project assignments.
   * @param {Number} projectId
   */
  onProjectSelect = (projectId) => {
    const { authentication, dispatch } = this.props;
    const authRequest = {
      user: authentication.user,
      docType: DOCTYPE.PROJECT_ASSIGNMENT,
      projectId,
      creatorId: null,
    };
    const permissions = getPermissions(authRequest);

    dispatch(projActions.fetchDetails(projectId));
    dispatch(projActions.fetchProjectUnits(projectId));
    dispatch(projActions.fetchAllStaff(projectId));

    this.setState({ projectId, permissions, selectedStaff: null });
  };

  resetProjectId = () => this.setState({ projectId: 0, selectedStaff: null });

  selectTab = (tabId) => this.setState({ selectedTabId: tabId });

  handleChange_nameFilter = (e) => this.setState({ nameFilter: e.target.value });
  handleChange_roleFilter = (roleFilter) => this.setState({ roleFilter });
  handleSort_staff = (sortColumn_staff) => this.setState({ sortColumn_staff });
  handleClick_assignedStaff = (selectedStaff) => this.setState({ selectedStaff });

  handleChange_unitFilter = (e) => this.setState({ unitFilter: e.target.value });
  handleSort_units = (sortColumn_units) => this.setState({ sortColumn_units });
  handleClick_assignedUnit = (selectedUnit) => this.setState({ selectedUnit });

  toggleEditProjAssignmentModal = () => {
    const { dispatch, tab } = this.props;
    // Clear any cached employees list so next modal session can start afresh
    if (this.state.showEditProjAssignmentModal)
      dispatch({ type: USER.CLEAR_EMPLOYEES_LIST, tabId: tab.tabId });
    this.setState({
      showEditProjAssignmentModal: !this.state.showEditProjAssignmentModal,
    });
  };

  toggleEditProjUnitsModal = () =>
    this.setState({ showEditProjUnitsModal: !this.state.showEditProjUnitsModal });

  getUnitData = () => {
    const { sortColumn_units, unitFilter, projectId } = this.state;
    const { projectUnitLists } = this.props;
    const projUnitList = projectUnitLists[projectId] || [];
    const filteredByUnit = unitFilter
      ? projUnitList.filter((pu) => pu.distUnit.includes(unitFilter.trim()))
      : projUnitList;
    return _.orderBy(filteredByUnit, [sortColumn_units.path], [sortColumn_units.order]);
  };

  getStaffData = () => {
    const { sortColumn_staff, nameFilter, roleFilter, projectId } = this.state;
    const { projectStaffLists } = this.props;
    const projStaffList = projectStaffLists[projectId] || [];
    const filteredByName =
      nameFilter !== ""
        ? projStaffList.filter((ps) =>
            (ps.fullName + " " + ps.employeeNo)
              .toLowerCase()
              .includes(nameFilter.trim().toLowerCase())
          )
        : projStaffList;
    const filteredByRole =
      roleFilter !== null
        ? filteredByName.filter((ps) => ps.projectRoleId === roleFilter.value)
        : filteredByName;
    return _.orderBy(filteredByRole, [sortColumn_staff.path], [sortColumn_staff.order]);
  };

  renderProjectStatus = (status) => {
    let statusCaption = "";
    let statusClass = "";
    switch (status) {
      case "ADVERTISED":
        statusCaption = "Advertised";
        statusClass = "warning";
        break;
      case "PRE_CONST":
        statusCaption = "Pre-Const";
        statusClass = "info";
        break;
      case "IN_CONST":
        statusCaption = "In-Const";
        statusClass = "success";
        break;
      case "POST_CONST":
        statusCaption = "Post-Const";
        statusClass = "secondary";
        break;
      default:
        break;
    }
    statusClass = "span-bubble p-1 bg-" + statusClass;
    return <span className={statusClass}>{statusCaption}</span>;
  };

  renderStaffTableFilters = () => {
    const { nameFilter, roleFilter, projectId } = this.state;
    const { projRoleOptions, projectStaffLists } = this.props;
    return (
      <div className="d-flex flex-row flex-wrap w-100 pa-filter">
        <div className="pa-filter__input--name">
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text bg-lightgray">
                <FontAwesomeIcon icon="search" className="fa-fw text-muted" />
              </span>
            </div>
            <input
              name="nameFilter"
              id="nameFilter"
              className="form-control col-12 mr-2"
              value={nameFilter}
              onChange={this.handleChange_nameFilter}
              placeholder="Name"
            />
          </div>
        </div>
        <div className="pa-filter__select--proj-roles mr-2">
          <Select
            name="roleFilter"
            id="roleFilter"
            value={roleFilter}
            options={projRoleOptions}
            onChange={this.handleChange_roleFilter}
            isSearchable={false}
            placeholder="Filter by Role"
            isClearable
          />
        </div>
        <button
          type="button"
          name="editProjAssignment"
          id="editProjAssignment"
          className="btn btn-info pa-filter__btn--edit px-2"
          onClick={this.toggleEditProjAssignmentModal}
          disabled={
            // If project is not selected
            !projectId ||
            // If projStaffList hasn't been loaded yet
            !projectStaffLists[projectId]
            // If user doesn't have EDIT permission
            // !permissions.includes(docPermConstants.EDIT)
          }
        >
          <FontAwesomeIcon icon="edit" className="fa-fw mr-2" />
          Edit...
        </button>
      </div>
    );
  };

  renderProjAssignmentTable = () => {
    const { sortColumn_staff, selectedStaff } = this.state;
    const data = this.getStaffData();
    return (
      <div className="pa__table--wrapper border">
        <Table
          className="table table-sm table-hover"
          data={data}
          columns={this.columns_staff}
          idPropName="userId"
          selectedItemId={selectedStaff && selectedStaff.userId}
          sortColumn={sortColumn_staff}
          onSort={this.handleSort_staff}
          handleClick_tr={this.handleClick_assignedStaff}
        />
      </div>
    );
  };

  renderProjUnitsTableFilters = () => {
    const { unitFilter, projectId } = this.state;
    const { projectUnitLists } = this.props;
    return (
      <div className="d-flex flex-row flex-wrap w-100 pa-filter">
        <div className="pa-filter__input--dist-unit">
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text bg-lightgray">
                <FontAwesomeIcon icon="search" className="fa-fw text-muted" />
              </span>
            </div>
            <input
              name="nameFilter"
              id="nameFilter"
              className="form-control col-12 mr-2"
              value={unitFilter}
              onChange={this.handleChange_unitFilter}
              placeholder="Unit No."
            />
          </div>
        </div>
        <button
          type="button"
          name="editProjUnits"
          id="editProjUnits"
          className="btn btn-info pa-filter__btn--edit px-2"
          onClick={this.toggleEditProjUnitsModal}
          disabled={
            // If project is not selected
            !projectId ||
            // If projStaffList hasn't been loaded yet
            !projectUnitLists[projectId]
            // If user doesn't have EDIT permission
            // !permissions.includes(docPermConstants.EDIT)
          }
        >
          <FontAwesomeIcon icon="edit" className="fa-fw mr-2" />
          Edit...
        </button>
      </div>
    );
  };

  renderProjUnitsTable = () => {
    const { sortColumn_units, selectedUnit } = this.state;
    const data = this.getUnitData();
    return (
      <div className="pa__table--wrapper border">
        <Table
          className="table table-sm table-hover"
          data={data}
          columns={this.columns_units}
          idPropName="unitId"
          selectedItemId={selectedUnit && selectedUnit.unitId}
          sortColumn={sortColumn_units}
          onSort={this.handleSort_units}
          handleClick_tr={this.handleClick_assignedUnit}
        />
      </div>
    );
  };

  renderTabContent = () => {
    const { selectedTabId } = this.state;
    switch (selectedTabId) {
      case "staff":
        return (
          <>
            {this.renderStaffTableFilters()}
            {this.renderProjAssignmentTable()}
          </>
        );
      case "units":
        return (
          <>
            {this.renderProjUnitsTableFilters()}
            {this.renderProjUnitsTable()}
          </>
        );
      default:
        return;
    }
  };

  render() {
    const { tab, authentication } = this.props;
    const {
      permissions,
      projectId,
      selectedTabId,
      selectedUnit,
      selectedStaff,
      showEditProjAssignmentModal,
      showEditProjUnitsModal,
    } = this.state;
    return (
      <React.Fragment>
        <TitleBar titleText={"Project Assignment Tool (Mini-WEAT)"} />
        <div className="d-flex flex-row w-100">
          <div className="pa-panel-list">
            <div className="row">
              <div className="col-12">
                <ProjSelector
                  tabId={tab.tabId}
                  initProjectId={!isNullOrZero(tab.projectId) ? projectId : 0}
                  showProjectsFor={{
                    type: projSelectorConstants.USER_ASSIGNED,
                    lookupId: authentication.user.userId,
                  }}
                  onProjectSelect={this.onProjectSelect}
                  resetProjectId={this.resetProjectId}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="card m-2">
                  <div className="card-body p-2">
                    <ProjAssignmentTabs
                      projectId={projectId}
                      tabs={this.tabs}
                      selectTab={this.selectTab}
                      selectedTabId={selectedTabId}
                    />
                    <div className="tab-content pa-tab-content">
                      <div
                        className="tab-pane fade show active border border-secondary pa-tab-pane p-2"
                        role="tabpanel"
                      >
                        {this.renderTabContent()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="pa-panel-details">
            <div className="row">
              <div className="col">
                <ProjAssignmentDetails
                  tabId={tab.tabId}
                  projectId={projectId}
                  userId={selectedStaff?.userId}
                  renderProjectStatus={this.renderProjectStatus}
                />
              </div>
            </div>
          </div>
        </div>
        {showEditProjAssignmentModal && (
          <EditProjAssignmentModal
            tabId={tab.tabId}
            permissions={permissions}
            projectId={projectId}
            showEditProjAssignmentModal={showEditProjAssignmentModal}
            toggleEditProjAssignmentModal={this.toggleEditProjAssignmentModal}
          />
        )}
        {showEditProjUnitsModal && (
          <EditProjUnitsModal
            tabId={tab.tabId}
            projectId={projectId}
            permissions={permissions}
            showEditProjUnitsModal={showEditProjUnitsModal}
            toggleEditProjUnitsModal={this.toggleEditProjUnitsModal}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  authentication: state.authentication,
  projectUnitLists: state.projects.projectUnitLists || null,
  projectStaffLists: state.projects.projectStaffLists || null,
  projRoleOptions: state.projects.projRoles
    ? state.projects.projRoles.map((pr) => ({
        value: pr.projectRoleId,
        label: pr.description,
      }))
    : [],
});

export default connect(mapStateToProps)(ProjAssignment);

function ProjAssignmentTabs(props) {
  const { projectId, tabs, selectTab, selectedTabId } = props;

  const projStaffList = useSelector(
    (state) => state.projects.projectStaffLists[projectId] || []
  );
  const projUnitList = useSelector(
    (state) => state.projects.projectUnitLists[projectId] || []
  );

  const renderCount = (tabId) => {
    switch (tabId) {
      case "staff":
        return projStaffList.length;
      case "units":
        return projUnitList.length;
      default:
        return;
    }
  };

  const renderTab = (tab) => {
    return (
      <li key={tab.tabId} className="nav-item">
        <div
          className={`nav-link border-secondary border-bottom-0 pointer-cursor ${
            tab.tabId === selectedTabId ? "active border ta-tab--border" : ""
          }`}
          id={tab.tabId + "_tab"}
          data-toggle="tab"
          role="tab"
          onClick={() => selectTab(tab.tabId)}
        >
          {tab.label}
          <span className="badge badge-secondary ml-2">{renderCount(tab.tabId)}</span>
        </div>
      </li>
    );
  };

  return (
    <ul className="nav nav-tabs border-0" role="tablist">
      {tabs.map((tab) => renderTab(tab))}
    </ul>
  );
}
